export function formatYmd(date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export function daysBetweenInclusive(from, to) {
  if (!from || !to) return 0;
  const fromD = new Date(`${from}T12:00:00`);
  const toD = new Date(`${to}T12:00:00`);
  if (Number.isNaN(fromD.getTime()) || Number.isNaN(toD.getTime())) return 0;
  return Math.floor((toD - fromD) / (24 * 60 * 60 * 1000)) + 1;
}

export function validateDateRange(from, to, maxDays = 31) {
  if (!from || !to) return { ok: false, error: "Укажите даты периода." };
  const fromD = new Date(`${from}T12:00:00`);
  const toD = new Date(`${to}T12:00:00`);
  if (Number.isNaN(fromD.getTime()) || Number.isNaN(toD.getTime())) {
    return { ok: false, error: "Некорректный формат даты." };
  }
  if (fromD > toD) {
    return { ok: false, error: "Дата «С» не может быть позже даты «По»." };
  }
  const days = daysBetweenInclusive(from, to);
  if (days > maxDays) {
    return {
      ok: false,
      error: `Нельзя запросить данные более чем за ${maxDays} дн. Сейчас выбрано: ${days} дн.`,
    };
  }
  return { ok: true, days };
}

export function quickRangeDates(key) {
  const today = new Date();
  const to = formatYmd(today);
  switch (key) {
    case "yesterday_today":
      return { from: formatYmd(new Date(today.getTime() - 24 * 60 * 60 * 1000)), to, key };
    case "3days":
      return { from: formatYmd(new Date(today.getTime() - 2 * 24 * 60 * 60 * 1000)), to, key };
    case "week":
      return { from: formatYmd(new Date(today.getTime() - 7 * 24 * 60 * 60 * 1000)), to, key };
    case "month":
      return { from: formatYmd(new Date(today.getTime() - 30 * 24 * 60 * 60 * 1000)), to, key };
    default:
      return { from: to, to, key: "" };
  }
}
